import useTranslation from 'next-translate/useTranslation'
import Link from 'next/link'
import { connect } from 'react-redux'
import Router, { useRouter } from 'next/router'
import { setShowNavigation } from 'SRC/modules/vehicleParts/list/actions'
import ReactSVG from 'react-svg'
import translations from '../../../../public/data/translations.json'

const BottomNavigation = ({ setShowNavigation }) => {
	const { t, lang } = useTranslation('common')
	const router = useRouter()

	const locale = lang?.toUpperCase() || 'ME'

	const searchHref = { pathname: '/mobileAdFilter', query: { page: translations.pretragaOglasa[locale] } }
	let searchAs = `/${translations.pretragaOglasa[locale]}`

	const getActiveItem = () => {
		if (router?.pathname === '/') return 'all_ads'
		if (router?.pathname === '/category' || router?.pathname === '/search') return 'search'

		return ''
	}

	const activeItem = getActiveItem()

	return (
		<div className='bottom-navigation'>
			<div className={`bottom-navigation_item`}>
				<Link href='/' as='/'>
					<a>
						<ReactSVG src='/icons/home.svg' beforeInjection={svg => {
							svg.setAttribute('width', '30px')
							svg.setAttribute('height', '30px')
						}} />

						<p>{t('Svi oglasi')}</p>
					</a>
				</Link>

				<div className={`${activeItem === 'all_ads' ? 'active' : ''}`} />
			</div>


			<div className={`bottom-navigation_item`}>
				<Link href={searchHref} as={searchAs}>
					<a>
						<ReactSVG src='/icons/search.svg' beforeInjection={svg => {
							svg.setAttribute('width', '30px')
							svg.setAttribute('height', '30px')
						}} />

						<p>{t('Pretraga')}</p>
					</a>
				</Link>

				<div className={`${activeItem === 'search' ? 'active' : ''}`} />
			</div>

			<div className='bottom-navigation_item bottom-navigation_item--add'>
				<Link href='/addAd' as='/dodaj'>
					<a>
						<ReactSVG src='/icons/add_rounded.svg' wrapper='span' className='bottom-navigation_item--add-icon' beforeInjection={svg => {
							svg.setAttribute('width', '45px')
							svg.setAttribute('height', '45px')
						}} />

						<p>{t('Dodaj oglas')}</p>
					</a>
				</Link>
			</div>

			<div className='bottom-navigation_item'>
				<a
					href='javascript:void(0)'
					onClick={() => {
						Router.push({
							pathname: `/profile`,
							query: {
								page: 'notifikacije'
							}
						}, '/profil/notifikacije'
						)
					}}
				>
					<ReactSVG src='/icons/message.svg' beforeInjection={svg => {
						svg.setAttribute('width', '30px')
						svg.setAttribute('height', '30px')
					}} />

					<p>{t('Poruke')}</p>
				</a>
			</div>

			<div className='bottom-navigation_item'>
				<a href='javascript:void(0)' onClick={() => setShowNavigation(true)}>
					<ReactSVG src='/icons/navigation.svg' beforeInjection={svg => {
						svg.setAttribute('width', '30px')
						svg.setAttribute('height', '30px')
						svg.querySelectorAll('path').forEach(path => {
							path.setAttribute('fill', '#0377cd')
						})
					}} />

					<p>{t('Navigacija')}</p>
				</a>
			</div>
		</div>
	)
}

export default connect(null, { setShowNavigation })(BottomNavigation)
